<template>
  <v-dialog v-model="abierto" max-width="480">
    <v-card v-if="item">
      <v-card-title class="text-h6">No se puede preparar</v-card-title>
      <v-card-text>
        <p>
          {{ Math.ceil(item.quantity) }}× {{ item.product.name }}. Se le avisa al mesero para que lo cambie; el resto del pedido sigue.
        </p>
        <div class="mb-3">
          <v-chip v-for="m in motivos" :key="m" class="mr-1 mb-1" :outlined="motivo !== m" :color="motivo === m ? 'primary' : undefined"
            @click="motivo = m">{{ m }}</v-chip>
        </div>
        <v-checkbox v-if="motivo === 'Se agotó'" v-model="marcarAgotado" hide-details dense class="mt-0 mb-3"
          label="Marcar también el producto como agotado (no se podrá pedir hasta el próximo turno)"></v-checkbox>
        <ng-textarea-keyboard v-model="nota" :label="motivo === 'Otro' ? 'Qué pasó (obligatorio)' : 'Nota (opcional)'" :filled="false" :dense="false"></ng-textarea-keyboard>
        <div class="red--text caption" v-if="error">{{ error }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="enviando" @click="abierto = false">Volver</v-btn>
        <v-btn color="red darken-1" class="white--text" depressed :loading="enviando" :disabled="!puede" @click="confirmar">No se puede</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cargarAgotados } from "@/plugins/pos/agotados";
// La caja marca una línea ya enviada como «No se puede» (cocina sin pantalla, o el cocinero se lo dijo de palabra):
// la línea queda sin preparar, con quién y por qué, y el mesero recibe el aviso para cambiarla.
export default {
  name: "LineaNoSePuede",
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
    orderId: { type: String, default: "" },
  },
  data: () => ({
    motivos: ["Se agotó", "Falta un ingrediente", "No hay cómo prepararlo", "Otro"],
    motivo: null,
    nota: "",
    marcarAgotado: true,
    error: "",
    enviando: false,
  }),
  computed: {
    abierto: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    puede() {
      if (!this.motivo) return false;
      return this.motivo !== "Otro" || this.nota.trim().length >= 3;
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.motivo = null;
        this.nota = "";
        this.error = "";
      }
    },
  },
  methods: {
    async confirmar() {
      this.enviando = true;
      this.error = "";
      try {
        const reason = this.motivo + (this.nota.trim() ? ": " + this.nota.trim() : "");
        const r = await this.$http.post("api/v1/order-change-status-item/" + this.orderId + "/" + this.item.id, { status: "unavailable", reason, mark_sold_out: this.motivo === "Se agotó" && this.marcarAgotado });
        cargarAgotados(this.$http);
        if (r && r.success) {
          this.$set(this.item, "status", "unavailable");
          this.$emit("marcada", this.item);
          this.abierto = false;
        } else {
          this.error = (r && (r.msg || r.message)) || "No se pudo marcar. Inténtalo de nuevo.";
        }
      } catch (e) {
        this.error = (e && (e.msg || e.message)) || "No se pudo marcar. Revisa la conexión.";
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>
